import { combineReducers } from "redux";
import { reduxDimensions as dimensions } from "reducers/reduxDimensions";
// import { reduxTabBanners as tabBanners } from "reducers/reduxTabBanners";
// import { sagaBanners as banners } from "reducers/sagaBanners";

export default combineReducers({
   dimensions,
   // banners,
   // tabBanners,
});
